import React, { useState, useEffect } from "react";

const DEFAULT_INTERVAL_SECONDS = 6;
const MIN_INTERVAL_SECONDS = 2;

export default function Cover({data, isMobile}){
    const [active, setActive] = useState(0);
    const [paused, setPaused] = useState(false);

    // The cover's own image/caption is always the first slide; any extra
    // slides added in Strapi follow it. With no extra slides it is a plain
    // single image, exactly as before.
    const extra = ((data && data.slides) || []).filter((s) => s.image);
    const first = { image: data && data.image, caption: data && data.caption };
    const slides = first.image || !extra.length ? [first, ...extra] : extra;
    const count = slides.length;

    // Seconds between slides, set in Strapi (cover > interval).
    const seconds = Math.max(Number(data && data.interval) || DEFAULT_INTERVAL_SECONDS, MIN_INTERVAL_SECONDS);

    useEffect(() => {
      if (count < 2 || paused) return undefined;
      const id = setTimeout(() => setActive((i) => (i + 1) % count), seconds * 1000);
      return () => clearTimeout(id);
    }, [count, paused, seconds, active]);

    if (!data) return null;
    const venue=data.venue;
    const dates=data.dates;
    const current = slides[active % count] || {};
    const caption=current.caption;
    const go = (i) => setActive((i + count) % count);
    const title=data.title;

          return (

            <div className="cover-workshop text-white rounded container-workshop" style={{opacity: '.89', overflow: 'hidden'}}>
              {slides.map((slide, i) => (
                <div key={i} className="cover-slide" aria-hidden={i !== active} style={{backgroundImage: slide.image ? `url(${slide.image.url})` : undefined, opacity: i === active ? 1 : 0}} />
              ))}
              <div className="d-flex h-100">
                <div className="cover-container d-flex w-100 h-100 mx-auto flex-column">
                  <header className="mb-auto">
                    <div>
                      <nav className="nav nav-masthead d-flex justify-content-end">
                        <a className="nav-link social" aria-current="page" href="https://fb.com/AdityaL1SC" target="”_blank”"><i className="bi bi-facebook" /></a>
                        <a className="nav-link social" href="https://twitter.com/AdityaL1SC" target="”_blank”"><i className="bi bi-twitter" /></a>
                      </nav>
                    </div>
                  </header>   
                  <div className>
                    <div className=" row text-center m-0">
                      <div className="col-3 my-auto">
                        {/* <img class="img-fluid" src="{{images}}/logos/iit_logo_original.png" width="50vh" /> */}
                      </div>
                      {/*<div className="col-6  d-none d-sm-block">
                        <h1 className="cover-name rounded-pill"> Aditya-L1 Support Cell Workshop</h1>
                      </div>*/}
                      <div className="col-6">
                        <h1 className="cover-name rounded-pill">{title}</h1>
                        <br /><br />
                      </div>
                      </div> 
                     
                   <div className="row text-center m-0">
                      <div className="col-3 my-auto">
                        {/* <img class="img-fluid" src="{{images}}/logos/iit_logo_original.png" width="50vh" /> */}
                      </div>
                      <div className="col-6">
                        <h3 className="cover-name rounded-pill">@ {venue}<br/>{dates}</h3>
                        <br /><br />
                      </div>
                    </div>                      

                  </div>
                </div>
                <div>
                </div>
              </div>
              <div className="sticker bottom-right-bg " />
              <h5 className="bottom-right text-center" style={{fontSize: '0.5em'}}>{venue}<br />
               {dates}</h5>
              {caption && <div className="bottom-left text-white" style={{fontSize: '0.5em'}}>Image: {caption}</div>}
              {count > 1 && (
                <>
                  <button type="button" className="cover-arrow cover-arrow-prev" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} aria-label="Previous image" onClick={() => go(active - 1)}>&#8249;</button>
                  <button type="button" className="cover-arrow cover-arrow-next" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)} aria-label="Next image" onClick={() => go(active + 1)}>&#8250;</button>
                  <div className="cover-dots" onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
                    {slides.map((_, i) => (
                      <button type="button" key={i} className={`cover-dot${i === active ? " active" : ""}`} aria-label={`Show image ${i + 1}`} onClick={() => go(i)} />
                    ))}
                  </div>
                </>
              )}
            </div>
          );
        }
